import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"


import { StHeading } from './heading.styled';
import { headingProps } from './heading.shared';


export default /*#__PURE__*/_defineComponent({
  __name: 'NkHeading',
  props: headingProps,
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(StHeading), _mergeProps({ as: _ctx.as }, _ctx.$props), {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16, ["as"]))
}
}

})